import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'Blocks'
import { withGAEvent, stripWhiteSpace } from 'Utils'
import config, { gaSelectors } from 'Config'

class Breadcrumbs extends Component {
  render() {
    const { gaEventContext, items = [], className } = this.props

    const ListItem = props => {
      const domProps = Object.assign({}, props)
      delete domProps.children
      return <li {...domProps}>{props.children}</li>
    }

    const renderItem = (item, key) => {
      if (items.length === 1) {
        return renderLink(item, key)
      } else {
        return key === items.length - 1
          ? renderCurrentItem(item, key)
          : renderLink(item, key)
      }
    }

    const renderLink = (item, key) => {
      const { name, to } = item
      const metaProps = {
        itemProp: 'position',
        content: key
      }

      const LI = withGAEvent(ListItem, {
        category: gaSelectors.getBreadcrumbsSettings.category.replace(
          '$1',
          gaEventContext
        ),
        action: gaSelectors.getBreadcrumbsSettings.action,
        label: `${name} - ${to}`,
        additionalProps: {
          linkName: name,
          destinationUrl: to,
        },
      })

      return (
        <LI key={`breadcrumbs-${to}`} className={'list-item'}>
          <Link to={to}>
            {name}
            <meta {...metaProps} />
          </Link>
        </LI>
      )
    }

    const renderCurrentItem = item => (
      <ListItem key={`breadcrumbs-${item.name}`}>
        {stripWhiteSpace(item.name)}
      </ListItem>
    )

    return config.useBreadcrumbs ? (
      <ul className={className}>
        {items.map((item, key) => renderItem(item, key))}
      </ul>
    ) : null
  }
}

Breadcrumbs.displayName = 'Breadcrumbs'

Breadcrumbs.propTypes = {
  className: PropTypes.string,
  gaEventContext: PropTypes.string,
  items: PropTypes.array
}

Breadcrumbs.defaultProps = {
  gaEventContext: '',
  items: [],
  className: ''
}

export default Breadcrumbs
